import { mergeDeep, setOrderData } from '../../../helpers';

import { OrderScroll } from './order.scroll';

export class OrderStorage extends OrderScroll {
  /**
   * @returns {jsonForm}
   */
  getJsonData() {
    return Object.fromEntries(this.DataForm.entries());
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @returns {null|LocalData}
   */
  getJsonStorage() {
    if (window.localStorage.getItem('OrderFormStore')) {
      return JSON.parse(window.localStorage.getItem('OrderFormStore'));
    }
    return null;
  }

  setDataFromStorage() {
    if (this.getJsonStorage() !== null) {
      window.location.hash = `step-${this.getJsonStorage().states.step}`;
      this.setState(this.getJsonStorage().states);
      /* eslint-disable-next-line */
      for (const [key, value] of Object.entries(this.getJsonStorage().data)) {
        if (key !== 'v3_token') {
          setOrderData(key, value);
        }
      }

      [...this.order.querySelectorAll('form')].forEach((form) => {
        this.DataForm = form;
      });

      this.showResultInfo();
    } else {
      this.resetState();
    }
    return this;
  }

  /**
   * @param {LocalData} LocalData
   * @returns {OrderFormBySteps}
   */
  setStorage(LocalData) {
    let existStorage = window.localStorage.getItem('OrderFormStore');
    existStorage = existStorage ? JSON.parse(existStorage) : {};
    window.localStorage.setItem(
      'OrderFormStore',
      JSON.stringify(mergeDeep(existStorage, LocalData)),
    );
    return this;
  }
}
